import React from 'react';
import './Users.css';

const Users = ({
  users,
  teams,
  usersLoading,
  userSearch,
  statusMsg,
  roleEdits,
  teamEdits,
  onSearchChange,
  onReload,
  onRoleSelect,
  onRoleApply,
  onTeamSelect,
  onTeamApply,
  onBetaApprovalToggle,
  roleOptions,
  formatTeamName,
  sortKey,
  sortDir,
  onSort,
}) => {
  return (
    <div className="sa-card">
      <div className="sa-card-header">
        <h2>Users</h2>
        <div className="sa-actions">
          <input
            className="sa-input"
            placeholder="Search email/IGN/role"
            value={userSearch}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <button className="sa-btn ghost" onClick={onReload} disabled={usersLoading}>
            {usersLoading ? 'Loading...' : 'Reload'}
          </button>
        </div>
      </div>
      {statusMsg && <div className="sa-status">{statusMsg}</div>}

      <div className="users-table">
        <div className="users-head">
          <button className="sa-sortable" onClick={() => onSort('email')}>
            Email
            <span className="sa-sort-indicator">
              {sortKey === 'email' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
            </span>
          </button>
          <button className="sa-sortable" onClick={() => onSort('role')}>
            Role
            <span className="sa-sort-indicator">
              {sortKey === 'role' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
            </span>
          </button>
          <button className="sa-sortable" onClick={() => onSort('team')}>
            Team
            <span className="sa-sort-indicator">
              {sortKey === 'team' ? (sortDir === 'asc' ? '↑' : '↓') : ''}
            </span>
          </button>
          <span>Beta Approved</span>
          <span>Actions</span>
        </div>

        {users.map((u) => (
          <div className="users-row" key={u.id}>
            <div className="users-col">
              <div className="users-primary">{u.email || '—'}</div>
              {u.ign && <div className="users-secondary">{u.ign}</div>}
            </div>

            <div className="users-col">
              <select
                className="sa-select users-select"
                value={roleEdits[u.id] || u.role || ''}
                onChange={(e) => onRoleSelect(u.id, e.target.value)}
              >
                <option value="">Select role</option>
                {roleOptions.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            </div>

            <div className="users-col">
              <select
                className="sa-select users-select"
                value={teamEdits[u.id] ?? (u.teamId || '')}
                onChange={(e) => onTeamSelect(u.id, e.target.value)}
              >
                <option value="">No team</option>
                {teams.map((t) => (
                  <option key={t.id} value={t.id}>
                    {formatTeamName(t)}
                  </option>
                ))}
              </select>
            </div>

            <div className="users-col">
              <button
                className={`sa-link ${u.betaApproved ? 'approved' : ''}`}
                onClick={() => onBetaApprovalToggle(u.id)}
                style={{
                  color: u.betaApproved ? '#6ce5b1' : '#c7c7c7',
                  fontWeight: u.betaApproved ? '600' : '400',
                  cursor: 'pointer',
                  padding: '4px 8px',
                  borderRadius: '6px',
                  border: u.betaApproved ? '1px solid #6ce5b1' : '1px solid rgba(255, 255, 255, 0.2)',
                  background: u.betaApproved ? 'rgba(108, 229, 177, 0.1)' : 'transparent',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  if (!u.betaApproved) {
                    e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                    e.target.style.color = '#ffffff';
                  }
                }}
                onMouseOut={(e) => {
                  if (!u.betaApproved) {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#c7c7c7';
                  }
                }}
                title={u.betaApproved ? 'Click to unapprove' : 'Click to approve for beta access'}
              >
                {u.betaApproved ? '✓ Approved' : 'Click to Approve'}
              </button>
            </div>

            <div className="users-col users-actions">
              <button className="sa-link" onClick={() => onRoleApply(u.id)}>
                Apply role
              </button>
              <button className="sa-link" onClick={() => onTeamApply(u.id)}>
                Apply team
              </button>
            </div>
          </div>
        ))}

        {users.length === 0 && <div className="sa-empty">No users found.</div>}
      </div>
    </div>
  );
};

export default Users;
